import React, { useState, useRef, useEffect } from 'react';
import { Globe, ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const LanguageSelector = () => {
  const { language, setLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (newLanguage: 'en' | 'es') => {
    setLanguage(newLanguage);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 text-foreground/70 hover:text-foreground px-3 py-2 rounded-md text-sm font-medium"
      >
        <Globe className="h-4 w-4" />
        <span>{language.toUpperCase()}</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-24 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50">
          <div className="py-1" role="menu" aria-orientation="vertical">
            <button
              onClick={() => handleLanguageChange('en')}
              className={`${
                language === 'en' ? 'bg-accent/10 text-accent' : 'text-gray-700 hover:bg-gray-100'
              } group flex items-center w-full px-4 py-2 text-sm`}
              role="menuitem"
            >
              English
            </button>
            <button
              onClick={() => handleLanguageChange('es')}
              className={`${
                language === 'es' ? 'bg-accent/10 text-accent' : 'text-gray-700 hover:bg-gray-100'
              } group flex items-center w-full px-4 py-2 text-sm`}
              role="menuitem"
            >
              Español
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;